export default __webpack_public_path__ + "static/media/Slide32.682ab5f6.jpg";